module.exports = __webpack_public_path__ + "img/voice.b1a7ff86.svg";